
















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component({
    computed: {
        ...mapGetters({
            userTicketAllTypes: 'UserTickets/getUserTicketAllTypes',
        }),
    },
})
export default class AssistantDialog extends Vue {
    constructor() {
        super();
    }

    public returnTypeIconClasses(type: string) {
        let classes = '';

        switch (type) {
            case 'questions':
                classes = 'fal fa-question-circle btn btn-light-primary border-0';
                break;

            case 'feedback':
                classes = 'fal fa-megaphone btn btn-light-success border-0';
                break;

            default:
                classes = 'fal fa-toolbox btn btn-light-purple border-0';
        }

        return classes;
    }

    public setNewTicketType(typeId: number) {
        this.$store.dispatch(Actions.FETCH_USER_CURRENT_TICKET_TYPE, typeId);
    }

    public goTo(route: string) {
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_VISIBILITY, false);
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_COMPONENT, null);
        this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_WAS_OPENED_LOCALLY, null);

        if (this.$router.currentRoute.name !== route) {
            this.$router.push({ name: route });
        }
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_USER_TICKET_ALL_TYPES);
    }
}
